import { render, staticRenderFns } from "./scope131.vue?vue&type=template&id=55b3a5eb&scoped=true"
import script from "./scope131.vue?vue&type=script&lang=js"
export * from "./scope131.vue?vue&type=script&lang=js"
import style0 from "./scope131.vue?vue&type=style&index=0&id=55b3a5eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3a5eb",
  null
  
)

export default component.exports